import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReportsComponent from "./reports-component";
import {connect} from "react-redux";
import {loadReportsRequest, setReportUrl} from "./reports-action-creators";


class ReportsContainer extends Component {

  componentDidMount() {
    const { reports, loadReports } = this.props;
    !reports.length ? loadReports() : null;
  }

  render() {
    return <ReportsComponent {...this.props} />
  }
}


const mapStateToProps = state => ({
  reports: state.reports.reports,
  loading: state.reports.loading,
  error: state.reports.error
});


const mapDispatchToProps = dispatch => ({
  loadReports: () => dispatch(loadReportsRequest())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportsContainer));



// WEBPACK FOOTER //
// ./src/modules/reports/reports-container.js